import styled from 'styled-components';

export const Content = styled.div``;

/* Alignment and nothing else — see the note in the user list's copy. */
export const Div = styled.div`
  &.captal {
    text-transform: capitalize;
  }

  /* A zero response count is an absence, and reads like one. */
  &.zero {
    color: var(--text-faint);
  }
`;
